import * as React from "react";
import { useFormik, Formik, Form } from "formik";
import { UpdatePasswordValidator } from "../../../utils/validators/auth";
//components
import AuthLayout from "../../../layouts/authLayout/AuthLayout";
import {
  FormWrapper,
  FormHeaderText,
  FormSubTitle,
  Button,
} from "../styles/auth";
import FormInput from "../../../components/Forms/input/FormInput";

const UpdatePassword = () => {
  let initialValues = {
    password: "",
    confirmPassword: "",
  };
  const formik = useFormik({
    initialValues: {
      Password: "",
      Password__c: "",
    },
    validationSchema: UpdatePasswordValidator(),
    onSubmit: (values: any) => {
      console.log(values);
    },
  });
  return (
    <AuthLayout>
      <FormWrapper>
        <FormHeaderText>Update Password</FormHeaderText>
        <FormSubTitle>Update new password below. </FormSubTitle>
        <Formik
          initialValues={initialValues}
          validationSchema={UpdatePasswordValidator}
          // @ts-ignore
          onSubmit={formik.handleSubmit}
        >
          <Form>
            <FormInput
              label={"New Password"}
              // name="Password"
              type="password"
              placeholder="Enter new password"
              {...formik.getFieldProps("Password")}
              errorMessage={
                formik.touched.Password && formik.errors.Password
                  ? formik.errors.Password
                  : null
              }
            />

            <FormInput
              label={"Re-enter New Password"}
              // name="Password__c"
              placeholder="Re-enter new password"
              type="password"
              {...formik.getFieldProps("Password__c")}
              errorMessage={
                formik.touched.Password__c && formik.errors.Password__c
                  ? formik.errors.Password__c
                  : null
              }
            />

            <Button type="submit">Confirm</Button>

            <div className="mt-4 text-center text-sm font-medium">
              Don't have an account yet?{" "}
              <a
                href="https://mitigaterisk.com/contact-us/"
                target="_blank"
                rel="noreferrer"
                className="text-purple-300"
              >
                Contact us
              </a>
            </div>
          </Form>
        </Formik>
      </FormWrapper>
    </AuthLayout>
  );
};

export default UpdatePassword;
